import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, CATEGORIES } from "../lib/api";
import ShopMap from "../components/ShopMap";

export default function MapPage() {
  const [shops, setShops] = useState([]);
  const [params] = useSearchParams();
  const preset = params.get("cat");
  const [active, setActive] = useState(preset ? [preset] : CATEGORIES.map((c) => c.key));

  useEffect(() => {
    api.get("/shops").then((r) => setShops(r.data));
  }, []);

  const toggle = (k) => setActive((a) => a.includes(k) ? a.filter((x) => x !== k) : [...a, k]);
  const filtered = shops.filter((s) => active.includes(s.category));

  return (
    <main className="max-w-7xl mx-auto px-6 md:px-8 py-14 md:py-20" data-testid="map-page">
      <div className="mb-10">
        <span className="eyebrow">La grande carte</span>
        <h1 className="font-heading mt-4 text-[var(--agt-navy)]" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>
          L'annuaire, <span className="font-heading-accent">à la carte.</span>
        </h1>
        <p className="text-[var(--agt-ink-muted)] mt-6 max-w-2xl text-lg">Utilisez les filtres pour n'afficher que les catégories qui vous intéressent. Cliquez sur un pin pour découvrir la boutique.</p>
      </div>
      <div className="rounded-3xl overflow-hidden shadow-2xl">
        <ShopMap shops={shops} active={active} onToggle={toggle} height="75vh"/>
      </div>

      <div className="mt-16">
        <h2 className="font-heading text-3xl md:text-4xl mb-8 text-[var(--agt-navy)]">{filtered.length} résultats affichés</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((s) => {
            const c = CATEGORIES.find((x) => x.key === s.category);
            return (
              <div key={s.id} className="card-soft p-6" data-testid={`shop-card-${s.id}`}>
                <span className="inline-block px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-full" style={{ background: c.color, color: c.key === "sports" ? "#243559" : "white" }}>{c.label}</span>
                <h3 className="font-heading text-xl mt-4 leading-tight text-[var(--agt-navy)]">{s.name}</h3>
                <p className="text-xs text-[var(--agt-ink-muted)] mt-1 uppercase tracking-wider font-bold">{s.city}</p>
                <p className="text-sm text-[var(--agt-ink-muted)] mt-3 line-clamp-3 leading-relaxed">{s.description}</p>
                {s.website && <a href={s.website} target="_blank" rel="noreferrer" className="mt-4 text-sm font-bold text-[var(--agt-mustard-deep)] inline-block hover:text-[var(--agt-navy)]">Visiter ›</a>}
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}
